import List from '@/views/app/ClinicalCares/Priorities'
import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'

function ClinicalCarePrioritiesRoutes() {
  const { path } = useRouteMatch()

  return (
    <div>
      <Route path={path} exact>
        <List title="Petis - Parceiros / Prioridades" />
      </Route>
    </div>
  )
}

export default ClinicalCarePrioritiesRoutes
